import {
  CHANGE_PASSWORD_CONFIRMATION,
  HOURLY_SCHEDULE,
  NEWSLETTER_CONFIRMATION,
  NEWSLETTER_FORM_WIDGET,
  PURCHASE,
} from "../../routes";

/* eslint-disable import/no-anonymous-default-export */
export default () => {
  const navbarHiddenRoutes = [
    // PURCHASE,
    HOURLY_SCHEDULE,
    NEWSLETTER_FORM_WIDGET,
    NEWSLETTER_CONFIRMATION,
    CHANGE_PASSWORD_CONFIRMATION,
  ];

  const showNavBar = () => {
    if (navbarHiddenRoutes.includes(window.location.pathname)) {
      return false;
    } else {
      return true;
    }
  };

  return showNavBar();
};
